import { useQuery } from '@tanstack/react-query';
import { ReactNode, Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { userInfoKeys } from 'api/quires/queryKeys';
import { getUserInfo } from 'api/userApi';
import i18next from 'i18n/i18n';
import { useRecoilState } from 'recoil';
import { userInfoState } from 'recoil/user/atom';
import { getAcceptUserInfo } from 'util/commonUtil';
import { encryptString } from 'util/encryptUtil';

interface PingGuardProps {
  children: ReactNode;
}

const ERROR_PATH = '/error';
const HOME_PATH = '/home/status-board';
const LOGIN_MESSAGE = i18next.t('validation.gPortal');

const PingGuard = ({ children }: PingGuardProps) => {
  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const { pathname } = useLocation();

  const { data, refetch } = useQuery({
    queryKey: userInfoKeys.ping(pathname),
    queryFn: () => getUserInfo(),
  });

  useEffect(() => {
    if (!data) {
      return;
    }

    if (data.code === 200) {
      const { account, name, latestDt, role, factoryId, deptId, acceptUsers } =
        data.info;
      const encryptedRole = encryptString(role.toString());
      const encryptFactoryId = encryptString(factoryId);
      const encryptDeptId = encryptString(deptId);
      setUserInfo((prev) => ({
        ...prev,
        role: encryptedRole,
        name,
        account,
        latestDt,
        isAuthenticated: true,
        factoryId: encryptFactoryId,
        deptId: encryptDeptId,
        ...getAcceptUserInfo(role, acceptUsers),
      }));
    }
  }, [data]);

  return <Suspense>{children}</Suspense>;
};

export default PingGuard;
